import React from 'react';

export default ({color="#000", fontSize="20px"}) => (
<svg id="lupa" xmlns="http://www.w3.org/2000/svg" width={fontSize} height={fontSize} viewBox="0 0 20.355 20.42">
  <g id="Grupo_101" data-name="Grupo 101">
    <path id="Trazado_586" data-name="Trazado 586" d="M20.627,16.092l-3.363-3.361a9.268,9.268,0,0,0,1.019-4.074,8.662,8.662,0,1,0-8.662,8.657A9.281,9.281,0,0,0,13.7,16.3l3.363,3.361a2.464,2.464,0,0,0,3.567,0A2.653,2.653,0,0,0,20.627,16.092ZM9.622,15.277a6.62,6.62,0,1,1,6.624-6.62A6.609,6.609,0,0,1,9.622,15.277Z" transform="translate(-0.96)" fill={color}/>
  </g>
</svg>
)